
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/the-48-laws-of-power",
      function () {
        return require("private-next-pages/articles/the-48-laws-of-power.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/the-48-laws-of-power"])
      });
    }
  